var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6E6E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3333H26.6666C27.5833 13.3333 28.3333 14.0833 28.3333 15V25C28.3333 25.9166 27.5833 26.6666 26.6666 26.6666H13.3333C12.4166 26.6666 11.6666 25.9166 11.6666 25V15C11.6666 14.0833 12.4166 13.3333 13.3333 13.3333Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 15L20 20.8333L11.6666 15",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.639f843c6832f55b647c4cd6829f62ab.svg";
export { ForwardRef as ReactComponent };